export const leadsViewGuard = (to, from, next) => {
  const leadsViewSelected = JSON.parse(sessionStorage.getItem('leadsViewSelected'))
  const defaultView = leadsViewSelected || 'pipeline'

  next({ name: 'leads-view', params: { view: defaultView }, query: to.query, replace: true })
}
